export default function IntroContent() {
  return (
    <div className="overflow-y-auto">
      <p>
        Asema-aikataululla voi hakea liikennepaikan ajantasaisen aikataulun. Myöhässä kulkevista
        junista näytetään saatavilla olevat myöhässäkulun syyt. Jos kulkutiedot eivät päivity
        lähdejärjestelmään ajallaan, lasketaan junan aikataululle arvio junan senhetkisen
        GPS-sijainnin perusteella. Aikataulu päivittyy reaaliajassa.
      </p>
    </div>
  );
}
